import { ArrowLeft, CheckCircle } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link } from '@/components/common/CustomLink'
import { AuthenticationLayout } from '@/components/layout/AuthenticationLayout.tsx'

export function ResetPasswordSuccess() {
  const { t } = useTranslation()

  return (
    <AuthenticationLayout
      icon={<CheckCircle className='w-6 h-6 text-green-600' />}
      title={t('auth.passwordReset')}
      description={t('auth.passwordResetSuccessMessage')}
    >
      <div className='flex items-center justify-center pt-2'>
        <Link
          to='/login'
          className='flex items-center gap-2 text-sm text-gray-700 hover:text-gray-900'
        >
          <ArrowLeft className='w-4 h-4' />
          {t('auth.backToLogin')}
        </Link>
      </div>
    </AuthenticationLayout>
  )
}
